import React, { useState } from 'react';
import { QUESTIONS } from '../constants';
import { mono } from '../styles';
import { Btn, TextInput } from '../components/UI';

export default function Questionnaire({ ob, onUpdate }) {
  const [ans, setAns] = useState(ob.answers || {});
  const filled = Object.values(ans).filter(v => v && v.trim()).length;

  function submit() {
    const newDone = ob.completedSteps.includes('questionnaire')
      ? ob.completedSteps
      : [...ob.completedSteps, 'questionnaire'];
    onUpdate({ ...ob, answers: ans, completedSteps: newDone });
  }

  return (
    <div>
      <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 4 }}>Brand Questionnaire</div>
      <div style={{ ...mono, marginBottom: 14 }}>{filled} of {QUESTIONS.length} fields filled</div>
      <div style={{ background: '#f8f8f6', borderRadius: 12, padding: '16px 18px', marginBottom: 14 }}>
        {QUESTIONS.map(q => (
          <TextInput
            key={q.id} label={q.label}
            value={ans[q.id] || ''}
            onChange={e => setAns(p => ({ ...p, [q.id]: e.target.value }))}
            ph={q.ph} multi={q.multi}
          />
        ))}
      </div>
      <Btn dis={filled < 6} onClick={submit}>Submit Questionnaire</Btn>
    </div>
  );
}
